export const desireSurgery = [
  { label: "1-2 months", value: "OneToTwo", color: "pink darken-2" },
  { label: "3-6 months", value: "TreeToSix", color: "purple darken-2" },
  { label: "6-12 months", value: "SixToTwelve", color: "blue darken-2" },
];
